/**
 * QueryClient 설정
 *
 * B2B 도매 앱 특성:
 * - staleTime 5분: 상품/브랜드 데이터는 자주 바뀌지 않음
 * - gcTime 10분: 메모리 캐시 유지
 * - retry 1: 네트워크 오류 1회 재시도
 * - refetchOnWindowFocus false: B2B 앱은 탭 전환 시 재요청 불필요
 */

import { QueryClient } from "@tanstack/react-query";

import type { ApiError } from "@/shared/api/types";

export function createQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 5 * 60 * 1000,
        gcTime: 10 * 60 * 1000,
        retry: 1,
        refetchOnWindowFocus: false,
      },
      mutations: {
        retry: 1,
      },
    },
  });
}

export type { ApiError };
